import React from 'react'
import { useTranslation } from "react-i18next";

import Button from '@mui/material/Button'
import { makeStyles } from '@mui/styles'
import Typography from '@mui/material/Typography'

import { ReactComponent as BeginnerIcon } from 'images/icons/beginner.svg'

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  gridList: {
    display: 'flex',
    [breakpoints.down('sm')]: {
      padding: spacing(0, 3),
    },
  },
  button: {
    flex: 1,
    boxShadow: '0 0 4px 0 rgba(0,0,0,0.5)',
    borderRadius: '2px !important',
    display: 'flex !important',
    alignItems: 'center !important',
    height: '140px !important',
    [breakpoints.down('sm')]: {
      padding: '32px !important',
      flexDirection: 'column !important',
      justifyContent: 'start !important',
      height: 'auto !important',
    },
    [breakpoints.up('sm')]: {
      padding: '24px 48px !important',
    },
  },
  text: {
    fontWeight: 'bold',
    color: '#fff !important',
    [breakpoints.down('sm')]: {
      marginTop: '12px !important',
    },
    [breakpoints.up('sm')]: {
      marginLeft: '12px !important',
    },
  },
  space: {
    width: spacing(3),
  },
}))
export default function Guide({ style }) {
  const { t } = useTranslation();
  const classes = useStyles()
  const Grid = ({ icon, color, children, onClick }) => (
    <Button onClick={onClick} className={classes.button} style={{ background: color }}>
      {icon}
      <Typography variant="body1" className={classes.text}>
        {children}
      </Typography>
    </Button>
  )

  return (
    <div className={classes.gridList} style={style}>
      <Grid
        icon={<BeginnerIcon />}
        color="#3ac2a8"
        onClick={() => window.open(process.env.REACT_APP_FOR_BEGINNER_URL)}
      >
        {t("Word.ForThoseAttendingTheEventForTheFirstTime")}
      </Grid>
      <div className={classes.space} />
    </div>
  )
}
